import { render, staticRenderFns } from "./DeclarationOfSecurity.vue?vue&type=template&id=047c08e0&scoped=true&"
import script from "./DeclarationOfSecurity.vue?vue&type=script&lang=js&"
export * from "./DeclarationOfSecurity.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationOfSecurity.vue?vue&type=style&index=0&id=047c08e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c08e0",
  null
  
)

export default component.exports